'use strict';

import GraphQL from './graphql';

export default {
  fetchNext (type, city, first, after) {
    const query = `{
      eventsConnection(
        eventType:${type}, 
        eventCity:${city},
        first:${first},
        after:"${after}",
        ) {
        totalCount
        pageInfo {
          endCursor
          startCursor
          hasPreviousPage
          hasNextPage
        }
        edges {
          node {
            name
            location_name
            start_date
            time
            event_type_name
            event_city_name
            cta_uri
            cta_text
            image
          }
          cursor
        }
      }
    }`;

    return GraphQL.post(query);
  },

  fetchPrev (type, city, last, before) {
    const query = `{
      eventsConnection(
        eventType:${type}, 
        eventCity:${city},
        last:${last},
        before:"${before}"
        ) {
        totalCount
        pageInfo {
          endCursor
          startCursor
          hasPreviousPage
          hasNextPage
        }
        edges {
          node {
            name
            location_name
            start_date
            time
            event_type_name
            event_city_name
            cta_uri
            cta_text
            image
          }
          cursor
        }
      }
    }`;

    return GraphQL.post(query);
  }

};



// WEBPACK FOOTER //
// ./app/javascript/vue/services/events.js